import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalErrorService } from '@services/global-error.service';
import { catchError, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { OpenPositionsResponse } from '@interfaces/open-positions.model';
import { jobDtlsResponse, HiringRequestData } from '@interfaces/job-details.model';

@Injectable({
  providedIn: 'root',
})
export class JobDetailsService {
  private baseUrl = environment.apiUrl;
  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
  ) {}

  getJobDetails(id: number): Observable<jobDtlsResponse[]> {
    return this.http
      .get<jobDtlsResponse[]>(`${this.baseUrl}/hiring/open-positions/${id}`)
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        }),
      );
  }
  getOpenPositions(): Observable<OpenPositionsResponse> {
    return this.http
      .get<OpenPositionsResponse>(`${this.baseUrl}/hiring/open-positions`)
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        }),
      );
  }

  fileDownload(fileName: string): Observable<ArrayBuffer> {
    return this.http
      .get(fileName, {
        responseType: 'arraybuffer',
      })
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        }),
      );
  }

  updateRequestStatus(status: string, updatedBy: string, hiringRequestId: number): Observable<HiringRequestData> {
    const params = new HttpParams()
      .set('status', status)
      .set('updatedBy', updatedBy)
      .set('hiringRequestId', hiringRequestId.toString());
    return this.http
      .put<HiringRequestData>(
  `${this.baseUrl}/hiring/request/${hiringRequestId}?status=${status}&updatedBy=${updatedBy}`,
  {}
)
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        }),
      );
  }
}
